module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fc-Gd-Hc-Ib-Ja.a0bcaa2c.png";